import { render, staticRenderFns } from "./LogoCarousel.vue?vue&type=template&id=69681f86&scoped=true"
import script from "./LogoCarousel.vue?vue&type=script&lang=js"
export * from "./LogoCarousel.vue?vue&type=script&lang=js"
import style0 from "./LogoCarousel.vue?vue&type=style&index=0&id=69681f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69681f86",
  null
  
)

export default component.exports